import React from 'react'
import { useLocation } from 'react-router-dom';
import './completedForm.css'
import { Link } from 'react-router-dom';

export const CompletedForm = ({message}) => {

    const location = useLocation();
    const state = location.state || {}; // Manejo seguro si no se pasa state

  return (
    <main>
    <article className="a-completed">
        <section className="section-info">
            <i className="bi bi-check-circle bi-class-okay"></i>
            <h1>{state.title}</h1>

            {/* 👉La propiedad dangerouslySetInnerHTML permite renderizar contenido HTML sin escaparlo */}

            {state.message && <p dangerouslySetInnerHTML={{ __html: state.message }} />}
        

            <div className="submit-button smCompleted">
              <Link className="button-send" to={'./login'}>Aceptar</Link>
                {/* <Link type="submit"  className="button-send" value="Aceptar"/> */}
    
            </div>
        </section>
    </article>



</main>
  )
}
